/* Dermolie — theme.js */
(function () {
  'use strict';
  var qs = function (s, c) { return (c || document).querySelector(s); };
  var qsa = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* ---------- Menú móvil ---------- */
  var drawer = qs('[data-drawer]');
  function setDrawer(open) {
    if (!drawer) return;
    drawer.classList.toggle('is-open', open);
    drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
    document.body.style.overflow = open ? 'hidden' : '';
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-drawer-open]')) setDrawer(true);
    if (e.target.closest('[data-drawer-close]')) setDrawer(false);
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') setDrawer(false); });

  /* ---------- Toast ---------- */
  var toastEl = qs('[data-toast]');
  var toastTimer;
  function toast(html, isError) {
    if (!toastEl) return;
    toastEl.innerHTML = html;
    toastEl.classList.toggle('toast--error', !!isError);
    toastEl.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.hidden = true; }, 4500);
  }

  /* ---------- Contador del carrito ---------- */
  function refreshCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        qsa('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.hidden = cart.item_count === 0;
        });
        return cart;
      });
  }

  /* ---------- Añadir al carrito (AJAX) ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-product-form]');
    if (!form || e.defaultPrevented) return;
    /* Si el envío lo lanza otro botón (p. ej. una app de pago contra reembolso), no lo tocamos */
    if (e.submitter && !e.submitter.hasAttribute('data-atc')) return;
    e.preventDefault();
    var btn = qs('[data-atc]', form);
    if (btn && btn.disabled) return;
    var label = qs('[data-atc-label]', form);
    var original = label ? label.textContent : '';
    if (btn) { btn.disabled = true; if (label) label.textContent = 'Añadiendo…'; }

    fetch('/cart/add.js', {
      method: 'POST',
      body: new FormData(form),
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' }
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (res) {
        if (res.ok) {
          toast('Añadido al carrito <a href="/cart">Ver carrito</a>');
          return refreshCart();
        }
        toast(res.d.description || res.d.message || 'No se pudo añadir el producto.', true);
      })
      .catch(function () { toast('Ha ocurrido un error. Inténtalo de nuevo.', true); })
      .then(function () {
        if (btn) { btn.disabled = false; if (label) label.textContent = original; }
      });
  });

  /* ---------- Cantidad ---------- */
  document.addEventListener('click', function (e) {
    var minus = e.target.closest('[data-qty-minus]');
    var plus = e.target.closest('[data-qty-plus]');
    if (!minus && !plus) return;
    var wrap = e.target.closest('[data-qty]');
    var input = qs('input', wrap);
    var min = input.hasAttribute('data-cart-qty') ? 0 : 1;
    var val = parseInt(input.value, 10) || 1;
    input.value = plus ? val + 1 : Math.max(min, val - 1);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Carrito: actualizar al cambiar cantidad ---------- */
  document.addEventListener('change', function (e) {
    if (!e.target.matches('[data-cart-qty]')) return;
    var form = e.target.closest('form');
    var upd = qs('[name="update"]', form);
    if (form.requestSubmit) form.requestSubmit(upd); else form.submit();
  });

  /* ---------- Filtros de colección ---------- */
  qsa('form[data-autosubmit]').forEach(function (form) {
    form.addEventListener('change', function () { form.submit(); });
  });

  /* ---------- Compartir ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-share]');
    if (!b) return;
    var url = b.getAttribute('data-url');
    if (navigator.share) {
      navigator.share({ title: b.getAttribute('data-title'), url: url }).catch(function () {});
    } else if (navigator.clipboard) {
      navigator.clipboard.writeText(url).then(function () { toast('Enlace copiado'); });
    }
  });

  /* ---------- Vídeos en bucle: pausar fuera de pantalla ---------- */
  if ('IntersectionObserver' in window) {
    var vio = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var v = en.target;
        if (en.isIntersecting) { var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); } else { v.pause(); }
      });
    }, { threshold: 0.4 });
    qsa('.mg__video[autoplay]').forEach(function (v) { vio.observe(v); });
  }

  /* ---------- Producto ---------- */
  qsa('[data-product-section]').forEach(function (root) {
    var dataEl = qs('[data-variants]', root);
    var variants = dataEl ? JSON.parse(dataEl.textContent) : [];
    var form = qs('form[data-product-form]', root);
    var idInput = form ? qs('[data-variant-id]', form) : null;

    /* Galería */
    var items = qsa('[data-media]', root);
    var thumbs = qsa('[data-thumb]', root);
    function currentIndex() {
      for (var i = 0; i < items.length; i++) if (!items[i].hidden) return i;
      return 0;
    }
    function showMedia(id) {
      items.forEach(function (el) { el.hidden = String(el.getAttribute('data-media')) !== String(id); });
      thumbs.forEach(function (t) { t.classList.toggle('is-active', String(t.getAttribute('data-thumb')) === String(id)); });
    }
    function go(step) {
      if (!items.length) return;
      var n = (currentIndex() + step + items.length) % items.length;
      showMedia(items[n].getAttribute('data-media'));
    }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { showMedia(t.getAttribute('data-thumb')); }); });
    var prev = qs('[data-gallery-prev]', root), next = qs('[data-gallery-next]', root);
    if (prev) prev.addEventListener('click', function () { go(-1); });
    if (next) next.addEventListener('click', function () { go(1); });

    /* Variantes */
    var picker = qs('[data-variant-picker]', root);
    function selectedOptions() {
      return qsa('[data-option-index]', root).map(function (fs) {
        var checked = qs('input:checked', fs);
        return checked ? checked.value : null;
      });
    }
    function findVariant(opts) {
      for (var i = 0; i < variants.length; i++) {
        var ok = true;
        for (var j = 0; j < opts.length; j++) if (variants[i].options[j] !== opts[j]) { ok = false; break; }
        if (ok) return variants[i];
      }
      return null;
    }
    function setPrice(scope, v) {
      qsa('[data-price]', scope).forEach(function (p) {
        var cur = qs('[data-price-current]', p), cmp = qs('[data-price-compare]', p), badge = qs('[data-price-badge]', p);
        if (cur) cur.textContent = v.price;
        if (cmp) { cmp.textContent = v.compare; cmp.hidden = !v.onsale; }
        if (badge) { badge.textContent = '-' + v.percent + '%'; badge.hidden = !v.onsale; }
        p.classList.toggle('price--sale', v.onsale);
      });
    }
    function setButtons(v) {
      var btn = qs('[data-atc]', root);
      var text = btn ? (btn.getAttribute('data-atc-text') || 'Añadir al carrito') : 'Añadir al carrito';
      qsa('[data-atc-label]', root).forEach(function (l) { l.textContent = v && v.available ? text : (v ? 'Agotado' : 'No disponible'); });
      if (btn) btn.disabled = !(v && v.available);
      var sl = qs('[data-sticky-label]', root);
      if (sl) sl.textContent = v && v.available ? sl.getAttribute('data-text') : (v ? 'Agotado' : 'No disponible');
      var sb = qs('[data-sticky-btn]', root);
      if (sb) sb.disabled = !(v && v.available);
    }
    if (picker) {
      picker.addEventListener('change', function (e) {
        var fs = e.target.closest('[data-option-index]');
        var label = fs && qs('[data-option-selected]', fs);
        if (label) label.textContent = e.target.value;
        var v = findVariant(selectedOptions());
        setButtons(v);
        if (!v) return;
        if (idInput) idInput.value = v.id;
        setPrice(root, v);
        if (v.media) showMedia(v.media);
        if (window.history && history.replaceState) {
          var u = new URL(window.location.href);
          u.searchParams.set('variant', v.id);
          history.replaceState({}, '', u.toString());
        }
      });
    }

    /* Barra fija de compra (móvil) */
    var sticky = qs('[data-sticky-atc]', root);
    var anchor = qs('[data-atc]', root) || qs('.buy', root);
    if (sticky && anchor && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        var en = entries[0];
        sticky.hidden = en.isIntersecting || en.boundingClientRect.top > 0;
      });
      io.observe(anchor);
      var sb = qs('[data-sticky-btn]', sticky);
      if (sb) sb.addEventListener('click', function () {
        if (sb.getAttribute('data-action') === 'add' && form) {
          if (form.requestSubmit) form.requestSubmit(qs('[data-atc]', form) || undefined); else form.submit();
        } else {
          anchor.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      });
    }
  });
})();
